import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { RouterModule } from '@angular/router';
import { AgrPageToolbarModule } from '@next/core-lib/components';
import { AgrDialogModule } from '@next/core-lib/dialog';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { DeliveryOverviewComponent } from './components/delivery-overview/delivery-overview.component';
import { DeliveryRouterComponent } from './components/delivery-router/delivery-router.component';
import { FlockDeliveryDialogComponent } from './components/flock-delivery/flock-delivery.component';
import { DeliveryOverviewResolver } from './resolvers/delivery-overview.resolver';
import { DeliveryEffects } from './store/delivery.effects';
import * as deliveryReducer from './store/delivery.reducer';
import { PageTableFilterModule } from '../shared/components/page-table-filter/page-table-filter.module';

import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [DeliveryOverviewComponent, DeliveryRouterComponent, FlockDeliveryDialogComponent],
  imports: [
    CommonModule,
    SharedModule,
    PageTableFilterModule,
    AgrPageToolbarModule,
    MatSlideToggleModule,
    MatSelectModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,
    MatButtonModule,
    MatListModule,
    AgrDialogModule,
    RouterModule,
  ],
  providers: [
    DeliveryOverviewResolver,
    provideState('deliveryModule', deliveryReducer.reducer),
    provideEffects([DeliveryEffects]),
  ],
})
export class DeliveryModule {}
